<svelte:options customElement={{
  tag: "section-head",
  shadow:"none",
  props: {
    caption: { type: "String" },
    title: { type: "String" },
    text:  { type: "String" },
    biz:  { type: "String" },
  }
}} />


<script>
  import { onMount } from 'svelte';
  import gsap from 'gsap';
  import { ScrollTrigger } from 'gsap/ScrollTrigger';

  const isBiz = $derived(biz === "true" || biz === true);
  let {
    caption = "",
    title = "",
    text = "",
    biz = false
  } = $props();

  let h2Element; // h2要素への参照を保持する変数

  onMount(() => {
    gsap.registerPlugin(ScrollTrigger);

    if (h2Element) {
      const lettersSpan = h2Element.querySelector('.letters');
      if (lettersSpan) {
        // title文字列を<br>タグで分割し、各文字を<span>でラップする
        const parts = title.split(/(<br[^>]*>)/i); // <br>タグ（クラス指定などがあっても）を保持したまま分割
        let processedHtml = '';
        parts.forEach(part => {
          if (part.match(/<br[^>]*>/i)) {
            processedHtml += part; // <br>タグはそのまま追加
          } else {
            // それ以外のテキストは各文字を<span>でラップ
            processedHtml += part.split('').map(char => `<span class="letter">${char}</span>`).join('');
          }
        });
        lettersSpan.innerHTML = processedHtml;

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: h2Element,
            start: 'top 70%',
            toggleActions: 'play none none none',
          },
        });

        tl.from(lettersSpan.querySelectorAll('.letter'), {
          // translateX: -10,
          rotationY: -80,
          opacity: 0,
          // transformOrigin: '50% 50% -50px', // 4. 3D回転の基点を奥にずらす（重要）
          duration: 1.5,
          ease: 'expo.out',
          stagger: {
            each: 0.05,
            from: 'start',
          },
        });
      }
    }
  });
</script>


<div class={isBiz ? "owd-biz-section-head" : "spacing:bottom:40"}>
  <div class="owd-sub spacing:bottom:16">
    <span class="owd-sub-marker"></span>
    <p class="owd-heading:en">{caption}</p>
  </div>
  <h2 bind:this={h2Element} class={isBiz ? "owd-heading:07 " : " owd-heading:02:large spacing:bottom:16"}>
    <span class="text-wrapper"><span class="letters"></span></span> <!-- コンテンツはJSで挿入 -->
  </h2>
  <!-- <h2 class={isBiz ? "owd-heading:07" : "owd-heading:02:large spacing:bottom:16"}>{@html title}</h2> -->
  {#if text.length}
    <p class="owd-text:01">{@html text}</p>
  {/if}
</div>

<style lang="scss">

  .owd-biz-section-head{
    margin-bottom: 64px;
    h2{
      :global(.text-wrapper) {
        display: block; /* or inline-block */
        perspective: 500px;
        perspective-origin: 50% 50%;
      }
      :global(.letter) {
          display: inline-block;
          backface-visibility: hidden;
          transform-origin: left center;
          transform-style: preserve-3d;
      }
    }
    @include g.mobile () {
      margin-bottom: 40px;
      h2{
        @include g.owd-typography($fz: 'heading-2-large', $line-height-px: 48, $letter-spacing-tracking: 25, $font-weight: 600);
        padding: 3.5px 0;
      }
    }
  }
</style>
